var productSections = [
  {
    type: "featured",
    containerId: "featured-prod-container",
    imgUrl: "https://cdn.shopify.com/s/files/1/0795/4854/7410/files/winteks-choice-straight-tp-optimized.png?v=1732574461",
    title: "Winteks choice",
    imgWidth: "150px",
    specialImgSize: "90px"
  },
  {
    type: "bestsellers",
    containerId: "bestseller-prod-container",
    imgUrl: "https://cdn.shopify.com/s/files/1/0795/4854/7410/files/Bestseller_and_Customer_s_Choice_card_thumbn.png?v=1745979043",
    title: "Bestsellers",
    imgWidth: "300px",
    specialImgSize: "65px",
    additionalClass: "bestseller-card__img"
  },
  {
    type: "bargains",
    containerId: "bargain-prod-container",
    imgUrl: "https://cdn.shopify.com/s/files/1/0795/4854/7410/files/Huge-Sale-tp-optimized.png?v=1732575698",
    title: "Huge Sale",
    imgWidth: "150px",
    specialImgSize: "48px"
  },
  {
    type: "arrivals",
    containerId: "new-arrival-prod-container",
    imgUrl: "https://cdn.shopify.com/s/files/1/0795/4854/7410/files/new-arrival-tp-optimized.png?v=1732576179",
    title: "New Arrivals",
    imgWidth: "150px",
    specialImgSize: "50px",
    additionalClass: "new-arrival__image"
  }
];
